module.exports = __webpack_public_path__ + "img/text.387e3b10.png";